import { render, staticRenderFns } from "./ShowSubmissionDetailModal.vue?vue&type=template&id=390744bf&scoped=true&lang=pug"
import script from "./ShowSubmissionDetailModal.vue?vue&type=script&lang=js"
export * from "./ShowSubmissionDetailModal.vue?vue&type=script&lang=js"
import style0 from "./ShowSubmissionDetailModal.vue?vue&type=style&index=0&id=390744bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390744bf",
  null
  
)

export default component.exports